import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";

function CartPage() {
  const navigate = useNavigate();
  const [isBot, setIsBot] = useState(false);

  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    const botPatterns = [
      "bot", "crawler", "spider", "headless", "slurp",
      "curl", "wget", "python-requests", "axios", "node"
    ];
    const isBotDetected =
      botPatterns.some((pattern) => ua.includes(pattern)) ||
      navigator.webdriver ||
      window._phantom ||
      window.callPhantom ||
      window.__nightmare;
    setIsBot(isBotDetected);
  }, []);

  const updateQty = (id, qty) => {
    const newCart = cart.map((item) => (item.id === id ? { ...item, quantity: qty } : item));
    setCart(newCart);
    localStorage.setItem("cart", JSON.stringify(newCart));
  };

  const removeItem = (id) => {
    const newCart = cart.filter((item) => item.id !== id);
    setCart(newCart);
    localStorage.setItem("cart", JSON.stringify(newCart));
  };

  const totalPrice = cart.reduce(
    (sum, item) =>
      sum + Number(String(item.disprice).replace(/[₹,]/g, "")) * item.quantity,
    0
  );

  const mrpTotal = cart.reduce(
    (sum, item) =>
      sum + Number(String(item.total).replace(/[₹,]/g, "")) * item.quantity,
    0
  );

  const handleCheckout = () => navigate("/address", { state: { cart } });

  if (cart.length === 0) {
    return (
      <div className="container">
        <div style={{ display: "flex", maxWidth: "400px", margin: "0 auto", padding: "10px", alignItems: "center" }}>
          <button onClick={() => navigate(-1)} style={{ fontSize: "18px", marginRight: "10px", cursor: "pointer", border: "none", background: "none", color: "#333" }}>
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <h2 style={{ fontSize: "16px", fontWeight: "600", color: "#333" }}>My Cart</h2>
        </div>
        <div style={{ textAlign: "center", padding: "83px" }}>
          <h2 style={{ fontWeight: "400" }}>Cart Is Empty</h2>
          <button onClick={() => navigate("/")} className="ship-btn">
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="cart-header" style={{ display: "flex", alignItems: "center", padding: "10px" }}>
        <button onClick={() => navigate(-1)} style={{ fontSize: "18px", marginRight: "10px", cursor: "pointer", border: "none", background: "none", color: "#333" }}>
          <i className="fa-solid fa-arrow-left"></i>
        </button>
        <h2 style={{ fontSize: "16px", fontWeight: "600", color: "#333" }}>Your Cart</h2>
      </div>

      <main className="cart-page">
        <section>
          <div style={{ padding: "20px" }}>
            {cart.map((item) => {
              return (
                <div key={item.id} className="cart-item" style={{ borderBottom: "1px solid #ccc", padding: "10px 0" }}>
                  <div className="cart-item-main" style={{ display: "flex", alignItems: "center" }}>
                    <div className="cart-item-media" style={{ textAlign: "center" }}>
                      <img src={item.mainimg} alt={item.name} width={60} />
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 4 }}>
                        <select
                          className="cart-quantity"
                          value={item.quantity}
                          onChange={(e) => updateQty(item.id, Number(e.target.value))}
                          style={{
                            padding: "4px 8px",
                            border: "1px solid #b1afaf",
                            borderRadius: "5px",
                            color: "#656464",
                            background: "#fff",
                          }}
                        >
                          {[...Array(10).keys()].map((n) => (
                            <option key={n + 1} value={n + 1}>
                              Qty: {n + 1}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="cart-item-details" style={{ marginLeft: "10px" }}>
                      <h4 className="cart-item-name" style={{ fontWeight: "400", paddingLeft: "6px", marginBottom: "-11px" }}>
                        {item.name}
                      </h4>

                      <Box className="cart-item-rating" sx={{ display: "flex", alignItems: "center", mt: 1, ml: 0.5, fontSize: 12 }}>
                        <Rating
                          value={parseFloat((Math.random() * 0.9 + 4.0).toFixed(1))}
                          precision={0.1}
                          readOnly
                          size="small"
                          sx={{
                            "& .MuiRating-iconFilled": { color: "#008c00" },
                            "& .MuiRating-iconEmpty": { color: "#bdbdbd" },
                          }}
                        />
                        <span style={{ marginLeft: 6, color: "#555" }}>
                          {(Math.random() * 0.9 + 4.0).toFixed(1)} |{" "}
                          {Math.floor(20000 + Math.random() * 80000).toLocaleString()} Ratings
                        </span>
                      </Box>

                      <div style={{ fontSize: "14px" }} className="p-pricedet cart-item-price">
                        {isBot ? (
                          <span className="price">{item.total}</span>
                        ) : (
                          <>
                            <span className="discount">
                              <i className="fa-solid fa-arrow-down"></i>
                              {item.dis}
                            </span>
                            <span className="mrp">{item.total}</span>
                            <span className="price">{item.disprice}</span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="cart-item-actions" style={{ display: "flex", justifyContent: "end", margin: "27px 0" }}>
                    <button className="cart-action-btn" type="button">
                      <i className="fa-regular fa-bookmark"></i> Save for later
                    </button>
                    <button className="re-btn" onClick={() => removeItem(item.id)}>
                      <i className="fa-solid fa-trash"></i> Remove
                    </button>
                    <button className="cart-action-btn" type="button" onClick={handleCheckout}>
                      <i className="fa-solid fa-bolt"></i> Buy this now
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        <div className="container">
          <img src="/img/seq2.png" style={{ width: "100%" }} alt="seq" />
        </div>

        <section>
          <div className="cart-price-panel"
            style={{
              background: "#fff",
              margin: "10px 20px",
              borderRadius: "8px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
            }}
          >
            <h3 className="cart-price-title" style={{ fontSize: "18px", fontWeight: "500", paddingTop: "10px", borderBottom: "1px solid #787878af" }}>
              Price Details
            </h3>

            <div className="cart-price-line" style={{ padding: "6px", display: "flex", justifyContent: "space-between" }}>
                <span>MRP (incl. of all taxes)</span>
              <span>
                ₹
                {cart
                  .reduce(
                    (sum, item) =>
                      sum + Number(String(item.total).replace(/[₹,]/g, "")) * item.quantity,
                    0
                  )
                  .toLocaleString("en-IN")}
              </span>
            </div>

            {!isBot && (
              <>
                <div className="cart-price-line" style={{ padding: "6px", display: "flex", justifyContent: "space-between" }}>
                  <span>Fees</span>
                  <span>₹0</span>
                </div>

                <div className="cart-price-line" style={{ padding: "6px", display: "flex", justifyContent: "space-between" }}>
                  <span>Discounts</span>
                  <span style={{ color: "#388e3c" }}>
                    - ₹
                    {(
                      cart.reduce(
                        (sum, item) =>
                          sum +
                          (Number(String(item.total).replace(/[₹,]/g, "")) -
                            Number(String(item.disprice).replace(/[₹,]/g, ""))) *
                          item.quantity,
                        0
                      ) || 0
                    ).toLocaleString("en-IN")}
                  </span>
                </div>

              </>
            )}

            <div className="cart-total-line" style={{ padding: "6px", display: "flex", justifyContent: "space-between", fontWeight: "600", borderTop: "1px solid #ddd" }}>
              <span>Total Amount</span>
              <span>₹{totalPrice.toLocaleString("en-IN")}</span>
            </div>
            {!isBot && (
              <div className="cart-savings-banner">
                <i className="fa-solid fa-percent"></i>
                You'll save ₹
                {(
                  cart.reduce(
                    (sum, item) =>
                      sum +
                      (Number(String(item.total).replace(/[₹,]/g, "")) -
                        Number(String(item.disprice).replace(/[₹,]/g, ""))) *
                      item.quantity,
                    0
                  ) || 0
                ).toLocaleString("en-IN")} on this order!
              </div>
            )}
          </div>
        </section>

        <div className="footer-btn cart-footer">
          <div className="cart-footer-total">
            <span className="cart-footer-mrp">₹{mrpTotal.toLocaleString("en-IN")}</span>
            <strong>
              ₹{totalPrice.toLocaleString("en-IN")}
              <i className="fa-solid fa-circle-info"></i>
            </strong>
          </div>
          <button
            className="b-btn cart-place-order"
            onClick={handleCheckout}
          >
            Place Order
          </button>
        </div>
      </main>
    </>
  );
}

export default CartPage;
